/**
 * ExpandButton - The Intelligent Standard
 *
 * Icon button to expand a panel into a modal view.
 */

export interface ExpandButtonProps {
  onClick: () => void;
}

export function ExpandButton({ onClick }: ExpandButtonProps) {
  return (
    <button
      onClick={onClick}
      type="button"
      className="px-2 py-1.5 text-xs border rounded-md cursor-pointer font-medium transition-all duration-150"
      style={{
        borderColor: '#D1C9C4',
        background: 'white',
        color: '#8B7764',
      }}
      title="Expand"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 3H5C3.89543 3 3 3.89543 3 5V8M16 3H19C20.1046 3 21 3.89543 21 5V8M8 21H5C3.89543 21 3 20.1046 3 19V16M16 21H19C20.1046 21 21 20.1046 21 19V16"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
